/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

/**
 * Extract param value from URL location query params
 * @param name name of the parameter
 * @param location URL location object
 * @return param value if present
 */
export function getParam(name, location) {
    const match = (new RegExp(`[?&]${name}=([^&#]*)`)).exec(location.toString());
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

/**
 * Extract param value from URL location hash
 * @param name name of the parameter
 * @param location URL location object
 * @return param value if present, else undefined
 */
export function getHashParam(name, location) {
    if (!name || !location || !location.hash) {
        return undefined;
    }
    const locationHash = (location.hash.substr(0, 1) === '#') ? location.hash.substr(1) : location.hash;
    const hashMap = locationHash.split('&').map(v => v.split('=')).reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {});
    return hashMap[name];
}

/**
 * [getCCWebPathData grabs the relveant App fields from the url]
 * @return {[none]}
 */
export function getPathData() {
    const path = window.location.pathname.split('/');
    return {
        sectionId: path[2],
        subSectionId: path[3],
        isPDP: path[4],
        product: path[5],
    };
}
